<template>
    <div class="container-fluid">
        <Breadcrumb title="Add Balancer" v-bind:button-show="false" v-show="!$route.params.id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit Balancer #' + $route.params.id" v-bind:button-show="false"
                    v-show="$route.params.id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="$route.params.id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <MailServiceSettingForm @setLoading="setLoading"></MailServiceSettingForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import MailServiceSettingForm from './forms/MailserviceSettingForm';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'Balancer',
        components: {
            MailServiceSettingForm,
            Preloader, Breadcrumb
        },
        data() {
            return {
                loading: false,
            }
        },
        mounted() {
            if (this.$route.params.id) {
                this.loading = true;
            }
        },
        methods: {
            setLoading(value) {
                this.loading = value
            }
        }
    }
</script>

<style scoped>

</style>
